module.exports = __webpack_public_path__ + "5a6f83faf68973ef727b66065b88e358.png";